:host {
  display: contents;
}

:host ::slotted([slot='right']) {
  min-width: 300px;
}

.spw-header {
  display: flex;
  flex-direction: column;

  :host(.spw-ds-nav-open) & {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 100vw;
    overflow: hidden;
    height: 100%;
    z-index: 9999;
    background: white;
    @include breakpoint(lg) {
      position: relative;
      height: auto;
      width: auto;
      overflow: initial;
    }
  }

  &__title {
    ::slotted([slot='title']) {
      font-family: 'Arial';
      font-weight: bold;
      letter-spacing: -1px;
      color: var(--spw-colors-support-grey-grey-900);
      margin: 0;
      line-height: 1;
      font-size: 24px;
      @include breakpoint(md) {
        font-size: 28px;
      }
      @include breakpoint(lg) {
        font-size: 32px;
      }
    }
  }
  &__content {
    padding-top: 16px;
    padding-bottom: 16px;
    display: flex;
    justify-content: space-between;
    order: 1;
    @include breakpoint(lg) {
      order: initial;
    }
  }
  &__top {
    display: none;
    order: 3;
    padding-top: 16px;
    padding-bottom: 16px;
    :host(.spw-ds-nav-open) & {
      display: block;
    }
    background: var(--spw-colors-support-grey-grey-50);
    @include breakpoint(lg) {
      display: block;
      order: initial;
      margin-top: 16px;
      padding: 0;
      background: none;
    }
  }
  &__top-content {
    flex-direction: column;
    justify-content: left;
    @include breakpoint(lg) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }
  &__top-buttons {
    flex-wrap: wrap;
    flex-direction: column;
    spw-button {
      width: 100%;
      @include breakpoint(lg) {
        width: auto;
      }
    }
    @include breakpoint(lg) {
      flex-direction: row;
    }
    ::slotted([slot='user-space']) {
      width: 100%;
      @include breakpoint(lg) {
        width: auto;
      }
    }
  }
  &__right {
    display: none;
    @include breakpoint(lg) {
      display: flex;
      justify-content: flex-end;
    }
    a {
      font-size: 21px;
      color: var(--spw-colors-support-grey-grey-900);
      &:hover {
        opacity: 0.7;
      }
      &:active {
        opacity: 0.5;
      }
    }
  }
  &__hamburger {
    min-width: 40px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    text-align: center;
    font-size: 12px;
    color: var(--spw-colors-support-grey-grey-900);
    cursor: pointer;
    margin-left: 16px;
    spw-icon {
      font-size: 20px;
    }
    @include breakpoint(lg) {
      display: none;
    }
  }
  &__top-nav {
    display: none;
    gap: 32px;
    @include breakpoint(lg) {
      display: flex;
    }
    a {
      color: var(--spw-colors-support-grey-grey-600);
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
    &-current {
      a {
        position: relative;
        font-weight: 600;
        color: var(--spw-colors-support-grey-grey-900);
        &:after {
          position: absolute;
          top: -2px;
          right: -9px;
          width: 6px;
          height: 6px;
          background: var(--spw-ds-primary);
          border-radius: 50%;
          content: '';
        }
      }
    }
  }
}
